import axios from 'axios'
import {
  NAME_LIST_REQUEST,
  NAME_LIST_SUCCESS,
  NAME_LIST_FAIL,
  NAME_ADD_REQUEST,
  NAME_ADD_SUCCESS,
  NAME_ADD_FAIL,
  NAME_DELETE_REQUEST,
  NAME_DELETE_SUCCESS,
  NAME_DELETE_FAIL,
  NAME_ALL_REQUEST,
  NAME_ALL_SUCCESS,
  NAME_ALL_FAIL
} from '../constants/nameConstants'

import { API_URL } from '../apiUrl.js'

export const getNames =
  (pageNumbername = '', keyword = '') =>
  async (dispatch) => {
    axios.defaults.withCredentials = true

    try {
      dispatch({ type: NAME_LIST_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.get(
        `${API_URL}/name/list?pageNumbername=${pageNumbername}&keyword=${keyword}`,
        config
      )

      dispatch({ type: NAME_LIST_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: NAME_LIST_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }

export const getAllnames = () => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: NAME_ALL_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(`${API_URL}/name/all`, config)

    dispatch({ type: NAME_ALL_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: NAME_ALL_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const addName = (name) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: NAME_ADD_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(`${API_URL}/name/add`, name, config)

    dispatch({ type: NAME_ADD_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: NAME_ADD_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

export const deleteName = (id) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: NAME_DELETE_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.delete(`${API_URL}/name/del/${id}`, config)

    dispatch({ type: NAME_DELETE_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: NAME_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}
